import { LEGACY_TEAM_ACCESS } from 'domains/legacy-feature/access'
import React from 'react'
import ResourcePage from 'domains/dashboard-migration/resource-page'
import { MARKETING_RESOURCES } from 'domains/dashboard-migration/resources'

const marketing_migration_routes = {
  collapse: true,
  path: '/marketing',
  name: 'Marketing Team',
  icon: 'fas fa-bullhorn text-indigo',
  state_key: 'marketing_migration_collapse',
  views: Object.keys(MARKETING_RESOURCES).map((resourceKey) => ({
    path: `/marketing/${resourceKey.replace(/_/g, '-')}`,
    name: MARKETING_RESOURCES[resourceKey].title,
    miniName: MARKETING_RESOURCES[resourceKey].title.split(' ').map((word) => word[0]).join(''),
    allowedRoles: MARKETING_RESOURCES[resourceKey].roles,
    allowedEmails: LEGACY_TEAM_ACCESS.Marketing.allowedEmails,
    component: (props) => <ResourcePage { ...props } resourceKey={ resourceKey } />,
    layout: '/app'
  }))
}
export default marketing_migration_routes
